import { Component } from '@angular/core';

@Component({
    selector: 'app-filter-chip',
    templateUrl: './filter-chip.component.html',
    styleUrls: ['./filter-chip.component.scss'],
    standalone: false
})
export class FilterChipComponent {

}
